import './Backdrop.scss';

export interface IBackdrop {
  show: boolean;
  onClick?: () => void;
  opacity?: number;
}

const Backdrop = ({ show, onClick, opacity = 0.75 }: IBackdrop) => {
  return (
    <div
      className={`backdrop ${show ? 'visible' : ''}`}
      style={{ backgroundColor: `rgba(0, 0, 0, ${opacity})` }}
      onClick={() => {
        if (!onClick) {
          return;
        }

        onClick();
      }}
    ></div>
  );
};

export default Backdrop;
